import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import FormComponent from '../FormComponent';
import { InputTypes, validFormElementValue } from '../../utils/validateFormElement';
import { Events } from '../../utils/dom/html-events';
import intlTelInput from 'intl-tel-input';

class ContactNumber extends FormComponent {
	init(questionData) {
		this.renderInputField(questionData);
	}
	markup(value, data = {}, titleMarkup) {
		this.inputFieldContainerClass = `lta-contact-number-input-field-container-${data.id}`;
		this.inputID = `lta-contact-number-input-field-id-${data.id}`;
		const placeholderText = data.placeHolder || '';
		const inputValue = data.value || '';
		const inputType = data.type || 'tel';
		const inputName = `lta-contact-number-input-field-name-${data.id}`;
		return `<div class="lta-contact-number-input-field">
					<div class="lta-contact-number-input-field-title">${titleMarkup}</div>
					<div class="lta-text-input__wrapper ${this.inputFieldContainerClass} u-mb-3">
						${this.renderInstructionLabel(data.instructionText)}
						${this.renderLabel(this.inputID)}
						<div class="lta-text-input--error"></div>
                        <input 
							type="${inputType}"
                            class="lta-text-input u-mb-3" 
                            id="${this.inputID}"
                            name="${inputName}" 
                            placeholder="${placeholderText}"
                            value="${inputValue}" 
                        />
					</div>
				</div>`;
	}

	renderLabel(inputID) {
		return this.data.titlePattern
			? ``
			: `<label for=${inputID} class="lta-text-input__label u-text-grey-lta">${this.data.label}</label>`;
	}

	renderInstructionLabel(instructionLabel) {
		return instructionLabel
			? `<div class="u-mb-2"><span class="lta-contact-number-input-field__label-instruction">${instructionLabel}</span></div>`
			: '';
	}

	afterRender() {
		this.componentElement = SelectorEngine.findOne('.lta-contact-number-input-field', this._element);
		this.inputFieldContainerElement = SelectorEngine.findOne(`.${this.inputFieldContainerClass}`, this._element);
		this.inputFieldElement = SelectorEngine.findOne(`#${this.inputID}`, this.inputFieldContainerElement);
		this.countryCodeInput = intlTelInput(this.inputFieldElement, {
			preferredCountries: ['gb'],
			separateDialCode: true
		});

		EventHandler.on(this.inputFieldElement, 'input', () => {
			this.inputFieldElement.value = this.inputFieldElement.value.replace(/[^0-9]/g, '');
		});

		if (this.data?.value) {
			setTimeout(() => {
				this.handleInput();
			}, 100);
		}

		EventHandler.on(this.inputFieldElement, Events.Blur, () => {
			this.handleInput();
		});
	}

	handleInput() {
		this.inputValue = this.inputFieldElement.value;
		this.validate();

		if (this.inputValue) {
			this.value = {
				...this.data,
				value: '+' + this.countryCodeInput.getSelectedCountryData().dialCode + this.inputValue
			};
		}
		if (this.value) {
			this.dependentQuestion = this.value.dependentQuestion;
		}
	}

	validate() {
		const formElementData = {
			hasIcon: false,
			type: this.data?.type,
			minLength: this.data.minLength,
			formElement: this.inputFieldElement,
			errorMessage: this.data.errorMessage,
			inputType: InputTypes.SELECTOR_INPUT,
			element: this.inputFieldContainerElement,
			minLengthErrorMessage: this.data.minLengthErrorMessage
		};

		return this.data?.isOptional ? true : validFormElementValue(this.inputValue, formElementData);
	}
}
export default ContactNumber;
